<template>
  <v-layout data-qa="editdisplay-layout-60h73"> 
    <v-text-field
      outlined
      dense
      v-model="localTextFieldValue"
      :rules="[validateInput]"
      :class="['data.valueClass', 'compact-text-field']"
      class="subheading font-weight-regular"
      :error="hasError"
      :error-messages="hasError ? errorMessage : ''"
     data-qa="editdisplay-text-field-4n5yn"></v-text-field>
    <v-icon 
      class="material-symbols-outlined" 
      size="20px"
      :disabled="isDisabled ? true : undefined"
      :color="isDisabled ? greyColor : successColor"
      :class="{ 'disabled-icon': isDisabled }"
      @click="updateAccountName(accountIdDisplay,localTextFieldValue)" data-qa="editdisplay-icon-7yj02">
          check
      </v-icon>
      <v-icon 
        class="material-symbols-outlined" 
        size="20px"
        :color="errorColor"
        @click="deleteEditedValue"
        style="cursor: pointer; margin-left: 8px;" data-qa="editdisplay-icon-idlar7">
          close
      </v-icon>
  </v-layout>
</template>
<script>
import '@/styles/components/displayDetails.scss'
import commonService from '@/service/commonService.js'

export default {
  name: 'DisplayDetails',
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    isEditingDisplay: { 
        type: Boolean
    },
    accountIdDisplay: { 
        type: String
    },
    textFieldValue: { 
        type: String
    }
  },
  data () {
    return {
      data: {
      },
      errorMessage: '',
      hasError: true,
      isDisabled: true,
      originalValue: this.textFieldValue,
      localTextFieldValue: this.textFieldValue,
      localIsEditingDisplay: this.isEditingDisplay,
      enableEditIcon: this.$appSettings.defaultConfigurations.accountDetailsScreen.enableEditIcon
    }
  },
  methods: {
    validateInput(value) {
      this.errorMessage = this.$t('accountDetails.errorMsgValidCharacters')
      const regex = /^[a-zA-Z0-9.'\-\s]*$/ 
      // Skip validation if input is empty
      if (!value) {
        this.hasError = false
        this.isDisabled = true
        return true
      }
      if (value.length > 25) {
        this.hasError = true
        this.errorMessage = this.$t('accountDetails.errorMsgMaximumlength')
        this.isDisabled= true
        return this.errorMessage
      }
      // Check if the input starts with ., ', or -
      if (/^[ .'-]/.test(value)) {
          this.hasError = true
          this.errorMessage = this.$t('accountDetails.errorMsgInvalidFormat')
          this.isDisabled = true
          return this.errorMessage
      } 
      // Validate the input against regex and check for decimal values
      const hasDecimalValue = value.includes('.') && /\.\d+/.test(value)
      this.hasError = !regex.test(value) || hasDecimalValue
      this.isDisabled = value.trim() === '' || this.hasError
      return !this.hasError

    },
    async updateAccountName(accountIdDisplay,editedValue) {
      // Request Body
      const requestBody = { 
        accountAdditionalDetails: { 
          accountName: editedValue 
        } 
      }
      const response = await commonService.updateAccountDetails(accountIdDisplay,requestBody)

      if(response && !response.causes){
        this.localIsEditingDisplay = false
        this.$emit('updateEditAndFieldValue', this.localIsEditingDisplay, editedValue)

        const accounts = this.$store.getters['userStore/userData'].myAccounts

        const updateAccountList = (accountList) => {
          accountList.forEach(account => {
            if (account.accountId === accountIdDisplay) {
              account.accountName = editedValue
            }
          })
        }

        updateAccountList(accounts.savingAccounts?.accountList)
        updateAccountList(accounts.currentAccounts?.accountList)
        updateAccountList(accounts.noticeAccounts?.accountList)
        updateAccountList(accounts.taxAccounts?.accountList)
        updateAccountList(accounts.noticeTaxAccounts?.accountList)

        this.$store.dispatch('userStore/setUserData', {myAccounts: accounts})

      } else {
        this.$store.dispatch('appStore/setAppData', {
          message: {
            title: 'Error',
            width: 400,
            persistent: true,
            saveButton: this.$t('common.okay'),
            content: this.$t('accountDetails.updateAccountErrorMsg'),
            type: 'error',
            component: 'dob-modal'
          }
        })
      }
    },
    deleteEditedValue() {
      this.localIsEditingDisplay= false
      this.$emit('updateEditAndFieldValue', this.localIsEditingDisplay, this.originalValue)
    }
  },
  watch: { 
    textFieldValue(newVal) { 
      this.localTextFieldValue = newVal
    },
    isEditingDisplay(newVal) { 
      this.localIsEditingDisplay = newVal 
    } 
  }
}
</script>

<style>
.compact-text-field .v-input__control {
    height: -1px; 
}

.compact-text-field .v-input__slot {
    padding-top: 1px;  
    padding-bottom: 1px; 
    font-size: 14px;     
    line-height: 1.2;    
}
.disabled-icon {
  opacity: 0.5; 
  pointer-events: none; 
  cursor: not-allowed;
}

</style>